export const userState = {
  userDetails: null,
  isLoggedIn: true,
  location: null,
};
